import { render, staticRenderFns } from "./view-template-modal.vue?vue&type=template&id=06a1ec4a&scoped=true"
import script from "./view-template-modal.vue?vue&type=script&lang=js"
export * from "./view-template-modal.vue?vue&type=script&lang=js"
import style0 from "./view-template-modal.vue?vue&type=style&index=0&id=06a1ec4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a1ec4a",
  null
  
)

export default component.exports